import moment from "moment";

import dateUtil from "../../../lib/dateUtil";
import { InsuredPerson } from "../../../providers/dlpFlow/DlpFlow.interfaces";

export const calculateMaxDuration = (
  insuredPersons: Partial<InsuredPerson>[],
  effectiveInsured: string[],
  effectiveDate?: moment.MomentInput
) => {
  const effective = dateUtil.dutchDateToMoment(effectiveDate);
  const minDuration = 10;
  const maxAge = 74; // Max age should be under 75 (so we need to calculate with 74)

  if (!effectiveInsured) {
    return maxAge;
  }

  let oldestInsured = 0;
  if (effectiveInsured.length === 2) {
    // Filter the oldest of 2 insured
    oldestInsured = Math.max(
      calculateAge(effective, insuredPersons[0].dateOfBirth),
      calculateAge(effective, insuredPersons[1].dateOfBirth)
    );
  } else {
    const insured = insuredPersons.find((ip) => (ip.personId ? effectiveInsured.includes(ip.personId) : false));
    if (insured) {
      oldestInsured = calculateAge(effective, insured.dateOfBirth);
    }
  }

  // Max duration is 75 - age = max duration in years
  const maxDuration = maxAge - oldestInsured;
  if (isNaN(maxDuration)) {
    return maxAge;
  }

  if (maxDuration < minDuration) {
    return minDuration;
  }

  return maxDuration;
};

export const calculateAge = (effectiveDate: moment.Moment, personDate: moment.MomentInput) => {
  const date = dateUtil.dutchDateToMoment(personDate);
  return effectiveDate.diff(date, "years");
};
